import { Plugin } from "@ckeditor/ckeditor5-core";
import ToolboxIcon from "./assets/filled-toolbox.svg";
import {
  addListToDropdown,
  createDropdown,
} from "@ckeditor/ckeditor5-ui";
import Model from "@ckeditor/ckeditor5-ui/src/model";
import { Collection } from "@ckeditor/ckeditor5-utils";
import { CkeditorConstants } from '../../src/utils/ckeditorconstants';

export default class AICommandsUI extends Plugin {
  static get pluginName() {
    return 'AiCommandsUI';
  }

  init() {
    const { editor } = this;
    editor.ui.componentFactory.add("showAICommands", this.addAICommands.bind(this));
  }

  addAICommands(locale) {
    const dropdownView = createDropdown(locale);

    dropdownView.id = "showAICommands";

    addListToDropdown(
      dropdownView,
      this.getLevelList()
    );

    dropdownView.buttonView.set({
      icon: ToolboxIcon,
      tooltip: "Show AI Commands",
    });

    return dropdownView;
  }

  getLevelList() {
    const AI_COMMANDS = CkeditorConstants.AI_COMMANDS;
    const itemDefinitions = new Collection();
    for (const { key: id, value: label } of AI_COMMANDS) {
      const definition = {
        type: "button",
        model: new Model({
          id,
          label,
          withText: true,
        }),
      };
      itemDefinitions.add(definition);
    }
    return itemDefinitions;
  }
}
